//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiChevronDown,
  mdiChevronUp,
  mdiDelete,
  mdiPencil,
  mdiReload,
  mdiTableColumn,
} from '@mdi/js'

export default {
  name: 'AuditTrail',
  data: () => ({
    secondApiUrl: null,
    dates: ['2020-01-01'],
    isLoading: false,
    icons: {
      mdiReload,
      mdiTableColumn,
      mdiChevronDown,
      mdiChevronUp,
      mdiPencil,
      mdiDelete,
    },
    organizations: [],
    selectedOrganization: null,
    years: [],
    selectedYear: null,
    headers: [],
    dataItems: [],
    allTableNames: [],
    allOperationTypes: [],
    tableSearch: {
      Name: '',
      Description: 1,

      SortBy: '',
      Sort: '',
      ItemsPerPage: 10,
      Page: 1,
      Organization: '',
      Year: '2021',
    },
    defaultTableSearch: {
      Name: '',
      Organization: 1,
      SortBy: '',
      Sort: '',
      ItemsPerPage: 10,
      Page: 1,
      Year: '2021',
    },
  }),

  created() {
    // this.userRoles = localStorage.getItem('userRoles')
    // const userRolesObj = JSON.parse(this.userRoles)
    // Object.keys(userRolesObj).forEach((key) => {
    //   if (key === '1' || key === '8660') {
    const apiUrls = this.$getApiUrls()
    this.$config.NUXT_API_SECOND_URL = apiUrls.secondApiUrl
    process.env.NUXT_API_BASE_URL = apiUrls.baseApiUrl
    this.secondApiUrl = this.$config.NUXT_API_SECOND_URL + '/audit-trail'
    // }
    // })
    this.$store.commit('layout/setTitle', this.$t('auditTrail_new.auditTrail'))

    this.headers = [
      {
        text: this.$t('auditTrail.etActionTstampStm'),
        align: 'start',
        sortable: true,
        isDateField: true,
        value: 'ChangedAt',
        verticalAlign: 'top',
        forceWidth: '144px',
      },
      {
        text: this.$t('auditTrail_new.etTableName'),
        align: 'start',
        sortable: true,
        value: 'TableName',
        dropdown: true,
        dropdownLabel: 'Label',
        dropdownValue: 'Value',
        dependency: 'allTableNames',
        allItems: [],
        forceWidth: '120px',
        translationPrefix: 'auditTrail.etTableName',
      },
      {
        text: this.$t('auditTrail.etAction'),
        align: 'start',
        sortable: true,
        value: 'OperationType',
        dropdown: true,
        dropdownLabel: 'Label',
        dropdownValue: 'Value',
        dependency: 'allOperationTypes',
        allItems: [],
        forceWidth: '144px',
      },
      {
        text: this.$t('auditTrail.etSessionUserName'),
        align: 'start',
        sortable: true,
        value: 'Email',
        search: true,
        forceWidth: '220px',
      },
      {
        text: this.$t('auditTrail.etClientAddr'),
        align: 'start',
        sortable: true,
        value: 'IP',
        forceWidth: '170px',
      },
      {
        text: this.$t('auditTrail.etRowData'),
        align: 'start',
        value: 'OriginalData',
        forceWidth: '420px',
        jsonFormat: false,
      },
      {
        text: this.$t('auditTrail.etChangedFields'),
        align: 'start',
        value: 'ChangedData',
        forceWidth: '420px',
        jsonFormat: false,
      },
    ]
  },
  methods: {
    updateDataItems(value) {
      this.dataItems = value
    },
    initFilters(filters) {
      this.organizations = filters.Organizations
      this.years = filters.Years

      if (this.selectedYear == null) {
        this.selectedYear = this.years[this.years.length - 1].Value
        this.selectedOrganization = this.organizations[0].OrganizationID
      }

      this.allOperationTypes = filters.OperationType
      this.allTableNames = filters.Tables

      this.headers.forEach((e) => {
        if ('dependency' in e) {
          e.allItems = this[e.dependency]
        }
      })
    },

    async filterTable() {
      await this.$refs.childTable.filterTable()
    },
  },
}
